import styled, { CSSObject, css } from "styled-components";
import { ChipProps } from "./Chip.types";
import { COLOR_VARIANT } from "../../constants/color-variant";
import { clickableCursorStyle, disabledCursorStyle } from "../../mixins/cursor";
import { fontWeightMixin } from "../../mixins/font";
const sizeBasedStyle: Partial<Record<`${ChipProps["size"]}`, CSSObject>> = {
    medium: {
        padding: "0px 20px",
        fontSize: "0.875rem",
        height: "44px",
    },
    small: {
        padding: "0 16px",
        fontSize: "0.875rem",
        height: "40px",
        gap: "5px",
    },
    xs: {
        padding: "0 20px",
        fontSize: "0.875rem",
        height: "36px",
        gap: "5px",
    },
    auto: {
        padding: "0 8px",
        fontSize: "0.875rem",
        height: "auto",
        gap: "5px",
    },
    dot: {},
};

export const StyledChip = styled.div<Partial<ChipProps>>`
    ${fontWeightMixin};
    display: inline-flex;
    gap: 10px;
    line-height: 1.5;
    white-space: nowrap;
    align-items: center;

    ${({
        outlined,
        filled,
        color,
        fillColor,
        faceColor,
        outlineColor,
        fontColor,
        showHoverEffect,
    }) => {
        const { primary, secondary } = COLOR_VARIANT[color!] ?? {};

        return css({
            color: fontColor ? fontColor : faceColor ?? primary,
            backgroundColor: filled ? fillColor ?? secondary : "white",
            borderStyle: "solid",
            borderWidth: outlined ? 2 : 0,
            borderColor: outlined
                ? outlineColor ?? faceColor ?? primary
                : "unset",
            ...(showHoverEffect && {
                "&:hover": {
                    backgroundColor: fillColor ?? secondary,
                },
            }),
        });
    }}

    ${({ radius = 4, blockWidth = false, size = "medium", dotSize = 2 }) => {
        return css({
            ...sizeBasedStyle[size],
            ...(size === "dot" && {
                minWidth: dotSize * 4,
                width: dotSize * 4,
                height: dotSize * 4,
            }),
            borderRadius: radius,
            width: blockWidth ? "100%" : "unset",
        });
    }}

    ${({ padded }) => {
        return padded
            ? ""
            : css({
                  padding: 0,
              });
    }}

    ${({ justifyContent }) => {
        return css({
            justifyContent: justifyContent ?? "flex-start",
        });
    }}

    ${({ onClick }) => onClick && clickableCursorStyle}
    ${({ disabled }) => disabled && disabledCursorStyle}
`;
